import axios from 'axios';

// Funzione per determinare il baseURL in base all'ambiente
const getBaseURL = () => {
  // Se siamo nel browser (non in Docker), usa localhost con porta
  if (typeof window !== 'undefined') {
    // In sviluppo locale
    if (window.location.hostname === 'localhost') {
      return 'http://localhost:5001/api';
    }
    // In produzione
    return `${window.location.origin}/api`;
  }
  // Fallback
  return 'http://backend:5000/api';
};

const API = axios.create({
  baseURL: getBaseURL(),
  headers: {
    'Content-Type': 'application/json',
  },
});

API.interceptors.request.use((config) => {
  const lang = localStorage.getItem('language') || 'en';
  config.headers['Accept-Language'] = lang;
  return config;
});

// Logging per debug (rimuovi in produzione)
API.interceptors.request.use(
  (config) => {
    console.log('🔵 API Request:', config.method.toUpperCase(), config.url);
    return config;
  },
  (error) => {
    console.error('❌ Request error:', error);
    return Promise.reject(error);
  }
);

API.interceptors.response.use(
  (response) => {
    console.log('🟢 API Response:', response.status, response.config.url);
    return response;
  },
  (error) => {
    console.error('❌ API Error:', error.message);
    if (error.response) {
      console.error('Status:', error.response.status);
      console.error('Data:', error.response.data);
    }
    return Promise.reject(error);
  }
);

export default API;